export default "__VITE_ASSET__CBUFM8J5__"